@if (visible()) {
  <p-message [severity]="severity()" size="small" [styleClass]="size() === 'regular' ? 'max-w-96' : ''">
    <div class="w-full h-full flex gap-2">
      <div class="flex flex-col py-2.5">
        <i [class]="iconMap[severity()]"></i>
      </div>
      <div class="flex flex-col flex-1 gap-2 pb-1">
        <div class="text-sm font-medium font-['Inter']">{{ title() }}</div>
        <div class="text-xs font-medium font-['Inter'] text-surface-700">{{ body() }}</div>
        <ng-content></ng-content>
      </div>
      @if (closable()) {
        <div class="flex flex-col">
          <p-button icon="fa fa-times" [severity]="severityMap[severity()]" text rounded size="small" (onClick)="closeToast()"></p-button>
        </div>
      }
    </div>
  </p-message>
}
